import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { MachineType } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class MachineTypeService extends TmsWebBaseEditService<MachineType, MachineType> {
  constructor() {
    super('MachineType', $localize`Machine Type`);
  }
}
